module.exports = __webpack_public_path__ + "static/img/IMG_20170907_191928.fb0a7ec5.jpg";